(function($) {
    if (!window.productConfiguratorInstance) {
        $(document).ready(() => {
            window.productConfiguratorInstance = new ProductConfigurator();
        });
    }                                           
})(jQuery); 